import { create } from 'zustand';
import { authAPI } from '../utils/api';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  refreshToken: localStorage.getItem('refreshToken'),
  isLoading: false,
  initialized: false,
  error: null,

  login: async (email, password, totp_token) => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await authAPI.login({ email, password, totp_token });
      if (data.requires_2fa) {
        set({ isLoading: false });
        return { requires_2fa: true };
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      set({ user: data.user, token: data.token, refreshToken: data.refreshToken, isLoading: false });
      return data.user;
    } catch (err) {
      set({ error: err.response?.data?.error || 'Giriş başarısız', isLoading: false });
      throw err;
    }
  },

  register: async (formData) => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await authAPI.register(formData);
      set({ isLoading: false });
      return data; // { message: '...' }
    } catch (err) {
      set({ error: err.response?.data?.error || 'Kayıt başarısız', isLoading: false });
      throw err;
    }
  },

  refreshTokens: async () => {
    const { refreshToken } = get();
    if (!refreshToken) return false;
    try {
      const { data } = await authAPI.refresh(refreshToken);
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      set({ token: data.token, refreshToken: data.refreshToken, user: data.user });
      return true;
    } catch {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      set({ user: null, token: null, refreshToken: null });
      return false;
    }
  },

  logout: async () => {
    const { refreshToken } = get();
    try { await authAPI.logout(refreshToken); } catch {}
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    set({ user: null, token: null, refreshToken: null });
  },

  fetchMe: async () => {
    try {
      const { data } = await authAPI.me();
      set({ user: data.user, initialized: true });
    } catch (err) {
      if (err.response?.status === 401) {
        // Token süresi dolmuş, refresh dene
        const ok = await get().refreshTokens();
        if (ok) {
          try {
            const { data } = await authAPI.me();
            set({ user: data.user, initialized: true });
            return;
          } catch {}
        }
      }
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      set({ user: null, token: null, refreshToken: null, initialized: true });
    }
  },
}));

export default useAuthStore;
